import type { MapProjectionHandle } from './types';

/**
 * Creates a persistent OverlayView for lat/lng → screen-pixel projection.
 * Used by hover tooltips to position at the correct screen coordinates.
 */
export function createProjectionOverlay(map: google.maps.Map): MapProjectionHandle {
  const overlay = new google.maps.OverlayView();
  overlay.onAdd = () => {};
  overlay.onRemove = () => {};
  overlay.draw = () => {};
  overlay.setMap(map);

  return {
    toScreenPoint(latLng: google.maps.LatLngLiteral) {
      const projection = overlay.getProjection();
      if (!projection) return null;
      const point = projection.fromLatLngToContainerPixel(new google.maps.LatLng(latLng));
      if (!point) return null;
      return { x: point.x, y: point.y };
    },
    cleanup() {
      overlay.setMap(null);
    },
  };
}
